import _ from "lodash";

import gameConfigurationField from "./formly/gameConfigurations";
import { defaultModelOptions } from "../../../../utils/modelOptions";
import machineServer from "../../Server/index";
import fieldHelpers from "../../../../ui-formly/fieldHelpers/index";
import { formlyEpromConfigurations } from "./formly/epromConfigurations";

function formly(asyncValidators, authService, machineConversion) {
  const manufacturerField = machineConversion
    ? fieldHelpers.simpleReadonlyField({
        key: "ManufacturerName",
        label: "Manufacturer",
      })
    : {
        key: "ManufacturerId",
        name: "ManufacturerId",
        type: "selectAsync",
        templateOptions: {
          label: "Manufacturer",
          required: true,
          showAddButton: authService.hasPermission("machineEdit"),
          query: [
            "$scope",
            machineServer.vsName,
            function ($scope, server) {
              return function (search) {
                return server.manufacturerQuery({
                  NameContains: search,
                  Skip: 0,
                  Take: 25,
                  OrderBy: "Name",
                });
              };
            },
          ],
          saveNewItem: [
            machineServer.vsName,
            function (server) {
              return function (name) {
                return server.manufacturerSave({
                  Name: name,
                });
              };
            },
          ],
          getDefaultItem: function (model) {
            return {
              Id: model.ManufacturerId,
              Name: model.ManufacturerName,
            };
          },
          updateNameProp: "ManufacturerName",
        },
        className: "col-xs-3",
        expressionProperties: {
          "templateOptions.readonly": "!!model.Id",
        },
      };

  const serialNumberField = machineConversion
    ? fieldHelpers.simpleReadonlyField({
        key: "SerialNumber",
        label: "Serial Number",
      })
    : {
        key: "SerialNumber",
        name: "SerialNumber",
        type: "input",
        templateOptions: {
          label: "Serial Number",
          required: true,
        },
        asyncValidators: {
          unique: {
            expression: asyncValidators.uniqueMachineSerialNumber,
          },
        },
        validation: {
          messages: {
            unique: function () {
              return "Serial Number is not unique";
            },
          },
        },
        modelOptions: defaultModelOptions,
      };

  const modelField = machineConversion
    ? fieldHelpers.simpleReadonlyField({
        key: "ModelName",
        label: "Model",
      })
    : {
        key: "ModelId",
        name: "ModelId",
        type: "selectAsync",
        templateOptions: {
          label: "Model",
          required: true,
          showAddButton: authService.hasPermission("machineEdit"),
          query: [
            "$scope",
            machineServer.vsName,
            function ($scope, server) {
              return function (search) {
                return server.modelQuery({
                  NameContains: search,
                  Skip: 0,
                  Take: 25,
                  OrderBy: "Name",
                });
              };
            },
          ],
          saveNewItem: [
            machineServer.vsName,
            function (server) {
              return function (name) {
                return server.modelSave({
                  Name: name,
                });
              };
            },
          ],
          getDefaultItem: function (model) {
            return {
              Id: model.ModelId,
              Name: model.ModelName,
            };
          },
          updateNameProp: "ModelName",
        },
        className: "col-xs-3",
        expressionProperties: {
          "templateOptions.readonly": "!!model.Id",
        },
      };

  var fields = [
    fieldHelpers.headerField({
      headerText: "Machine Information",
    }),
    fieldHelpers.columnLayout(
      [
        fieldHelpers.simpleStringField({
          key: "GameTheme",
          name: "GameTheme",
          label: "Game Theme",
        }),
        fieldHelpers.simpleStringField({
          key: "GameType",
          name: "GameType",
          label: "Game Type",
        }),
        serialNumberField,
        {
          key: "SlotNumber",
          name: "SlotNumber",
          type: "input",
          templateOptions: {
            label: "Asset Number",
          },
        },
        fieldHelpers.simpleStringField({
          key: "SlotMastId",
          label: "Slot Mast",
        }),
        locationField("Section"),
        locationField("Bank"),
        locationField("Slot"),
        manufacturerField,
        {
          key: "Ownership",
          name: "Ownership",
          type: "select",
          templateOptions: {
            required: true,
            label: "Ownership",
            options: [
              { name: "Participation", value: "Participation" },
              { name: "House", value: "House" },
              { name: "WAP", value: "Wap" },
              { name: "Daily", value: "Daily" },
            ],
          },
        },
        modelField,
        fieldHelpers.simpleStringField({ key: "OasisId", label: "Oasis ID" }),
        {
          key: "Status",
          name: "Status",
          type: "selectAsync",
          templateOptions: {
            required: true,
            label: "Status",
            query: [
              machineServer.vsName,
              function (server) {
                return function (search) {
                  return server.statusGet({
                    NameContains: search,
                  });
                };
              },
            ],
            getDefaultItem: function (model) {
              return {
                Id: model.Status,
                Name: model.Status,
              };
            },
          },
        },
        {
          key: "ReelType",
          name: "ReelType",
          type: "select",
          templateOptions: {
            required: true,
            label: "Reel Type",
            options: [
              { name: "Keno", value: "Keno" },
              { name: "Poker", value: "Poker" },
              { name: "Stepper", value: "Stepper" },
              { name: "Video", value: "Video" },
            ],
          },
        },
        fieldHelpers.simpleStringField({
          key: "LdcAssetNumber",
          label: "LDC Asset Number",
        }),
        fieldHelpers.simpleDateField({
          key: "InServiceDate",
          label: "In Service Date",
        }),
        fieldHelpers.simpleDateField({
          key: "Date",
          label: "Date",
          required: true,
        }),
      ],
      4
    ),
    gameConfigurationField(authService),
    fieldHelpers.columnLayout(
      [
        fieldHelpers.simplePercentageField({
          key: "BasePar",
          label: "Base PAR",
          min: 0,
          max: 100,
        }),
        fieldHelpers.simplePercentageField({
          key: "ProgressiveContribution",
          label: "Progressive Contribution",
          min: 0,
          max: 100,
        }),
        fieldHelpers.simplePercentageField({
          key: "TotalPar",
          label: "Total PAR",
          min: 0,
          max: 100,
        }),
        fieldHelpers.simpleCurrencyField({
          key: "TopProgressiveResetAmount",
          label: "Top Progressive Reset Amount",
          min: 0,
        }),
      ],
      4
    ),
    formlyEpromConfigurations(),
    fieldHelpers.headerField({ headerText: "Devices", key: "Devices" }),
    ...fieldHelpers.columnLayout(
      [
        {
          fieldGroup: [
            fieldHelpers.simpleStringField({
              key: "PrinterType",
              name: "PrinterType",
              label: "Printer",
            }),
            fieldHelpers.simpleStringField({
              key: "BillValidatorType",
              name: "BillValidatorType",
              label: "Bill Validator",
            }),
          ],
        },
      ],
      4
    ),
    {
      key: "Files",
      name: "Files",
      type: "fileUpload",
      templateOptions: {
        label: "Files",
      },
    },
    fieldHelpers.columnLayout(
      [
        fieldHelpers.textAreaField({
          key: "Notes",
        }),
      ],
      1
    ),
  ];

  return _.flatten(fields, false);

  function locationField(fieldName) {
    return {
      key: fieldName,
      name: fieldName,
      type: "input",
      templateOptions: {
        label: fieldName,
      },
      expressionProperties: {
        "templateOptions.required": isLocationRequired(fieldName),
      },
    };
  }

  function isLocationRequired(fieldName) {
    return function ($viewValue, $modelValue, scope) {
      var machine = scope.model;

      var modelController = scope.form[fieldName];
      var locationRequired = machine.Status === "Floor";

      if (modelController && !locationRequired) {
        modelController.$setValidity("required", true);
      }

      return locationRequired;
    };
  }
}

export default formly;
